export function loginLayoutConfig({ colors }) {
    return {
        background: {
            color: colors.background.loginLayoutBackground,
            position: "left center",
            repeat: "repeat-x",
            size: "1024px auto"
        },
        container: { width: "480px" }
    };
}
